
















import { defineComponent, type PropType } from "vue-demi";
import { formatPrice } from "@artmizu/utils";
import type { CombinePrice } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "MPPrice",
  props: {
    price: {
      type: Object as PropType<CombinePrice>,
      required: true,
    },
  },
  computed: {
    beautifyPriceCommon() {
      return this.price.common.value
        ? formatPrice(this.price.common.value)
        : null;
    },
    beautifyPriceDiscount() {
      return this.price.discount?.value
        ? formatPrice(this.price.discount?.value)
        : null;
    },
  },
});
